module.exports = __webpack_public_path__ + "img/features.3946684e.jpg";